module.exports = __webpack_public_path__ + "img/public/SiteIcons/expireIcon.svg?3add3ad3";